import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Typography,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import RecipeService from '../../services/recipe.service';

export default function MultipleWrite({ recipeGroupName, recipeName, params, open, close }) {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const dashboardName = "TagList";

  const handleSave = async () => {
    try {
      setLoading(true);
      setMessage("Write is in progress...");
      //console.log(params)

      const modbusTags = params.filter( item => item.TagType === "ModbusTag");

      const mqttTags = params.filter( item => item.TagType === "MQTTTag" );

      const systemTags = params.filter( item => item.TagType === "SystemTag" );

      const auditTrailData = [];
      //const response =1;
      //console.log(modbusTags)
      //console.log(mqttTags)
      //console.log(systemTags)

      const response = await RecipeService.saveAllData( dashboardName, modbusTags, mqttTags, systemTags, auditTrailData );

      if (response) {
        let dashboardName = "RecipeGroupList";
        let GroupName = recipeGroupName;
        let SelectedRecipe = recipeName;
        const response1 = await RecipeService.selectedRecipe(dashboardName, GroupName, SelectedRecipe);
        if(response1){
          setLoading(false);
          setMessage(response.data?.message || "Write completed successfully.");

          setTimeout(() => {
            close();
          }, 1000);
        }
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
      setMessage("Write failed.");
    }
  };

  const handleClose = () => {
    if (!loading) {
      setMessage("");
      close();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Multiple Parameter Write

        <IconButton
          aria-label="close"
          onClick={handleClose}
          disabled={loading}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ mt: 1 }}>
        {!loading ? (
          <DialogContentText>
            Are you sure you want to write{" "}
            <strong>{params?.length || 0}</strong> parameter(s)?
          </DialogContentText>
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            py={3}
          >
            <CircularProgress size={60} />

            <Typography mt={2} fontWeight={500}>
              {message}
            </Typography>
          </Box>
        )}

        {!loading && message && (
          <Typography
            color={message.includes("failed") ? "error" : "success.main"}
            mt={2}
          >
            {message}
          </Typography>
        )}
      </DialogContent>

      {!loading && (
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose}>Cancel</Button>

          <Button
            variant="contained"
            onClick={handleSave}
          >
            Write
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}